import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
Vue.use(Vuex);
import request from "@/request";
import url from "@/assets/js/urls.js";
export default new Vuex.Store({
    state: {
        userType: -1,
        userId: "",
        userArr: null,
        defaultUser: {},
    },
    getters: {},
    mutations: {
        SET_USER_TYPE: (state, userType) => {
            state.userType = userType;
            localStorage.setItem("currentRole", userType);
        },
        SET_DEFAULT_USER: (state, defaultUser) => {
            state.defaultUser = defaultUser;
        },
        SET_USER_Arr: (state, userArr) => {
            state.userArr = userArr;
        },
        SET_USER_ID: (state, userId) => {
            state.userId = userId;
            localStorage.setItem("userId", userId);
        },
        LOGOUT(state) {
            state.userType = -1;
            state.defaultUser = {};
            localStorage.removeItem("userId");
            localStorage.removeItem("currentRole");
            localStorage.removeItem("BIND_PHONE");
            // localStorage.setItem("currentRole",'')
        },
    },
    actions: {
        async getUserType({ dispatch, commit }, data) {
            await request.post({
                url: url.getType,
                isUrl: "mainBaseUrl",
                success: (res) => {
                    if (res.tag == 3) {
                        Vue.prototype.$notify.warning(res.msg);
                        dispatch("logout");
                        return;
                    }
                    if (res.tag == 4) {
                        // 需要绑定手机号
                        localStorage.setItem("BIND_PHONE", 1);
                    }
                    let roleUrl = window.location.href.split("/");
                    let userType = -1;
                    if (typeof res.result == "object") {
                        userType = res.result[0];
                        commit("SET_USER_Arr", res.result);
                    } else {
                        userType = res.result;
                    }
                    commit("SET_USER_TYPE", userType);
                    if (roleUrl.includes("student") && userType == 1) {
                        router.push(data.path.path);
                        data.next;
                    } else if (
                        roleUrl.includes("manager") &&
                        (userType == 2 ||
                            userType == 16 ||
                            userType == 32 ||
                            userType == 64 ||
                            userType == 128)
                    ) {
                        router.push(data.path.path);
                        data.next;
                    } else if (roleUrl.includes("teacher") && userType == 8) {
                        router.push(data.path.path);
                        data.next;
                    } else if (roleUrl.includes("society") && userType == 0) {
                        router.push(data.path.path);
                        data.next;
                    } else {
                        if (userType == 0) {
                            router.push({ path: "/society" });
                        } else if (userType == 1) {
                            // router.push({ path: '/student' })
                            window.location.href = "/skynotice/student";
                        } else if (
                            userType == 2 ||
                            userType == 16 ||
                            userType == 20 ||
                            userType == 24 ||
                            userType == 32 ||
                            userType == 64 ||
                            userType == 128
                        ) {
                            // router.push({ path: '/manager' })
                            window.location.href = "/skynotice/manager";
                        } else if (userType == 8 || userType == 12) {
                            // router.push({ path: '/teacher' })
                            window.location.href = "/skynotice/teacher";
                        }
                    }
                    dispatch("getDefaultUser", { type: userType });
                },
            });
        },
        getDefaultUser({ commit }, data) {
            request.post({
                url: url.getDefaultUser,
                isUrl: "mainBaseUrl",
                success: (res) => {
                    if (res.code == "ok") {
                        commit("SET_DEFAULT_USER", res.result);
                        commit("SET_USER_ID", res.result.user_id);
                    }
                },
            });
        },
        // 退出登录
        logout({ commit }) {
            request.get({
                url: url.logout,
                isUrl: "mainBaseUrl",
                success: (res) => {
                    commit("LOGOUT");
                },
            });
        },
    },
    modules: {},
});